module.exports = __webpack_public_path__ + "static/img/3.5adc900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimages/3.png
// module id = ytjY
// module chunks = 1